import {createLiveStartPlan} from './live-start-plan.js';

function active(values=[]){
  return (values||[]).filter(value=>!value?.deletedAt);
}

export function prepareLiveStart({
  session,
  bundle={},
  selectedStageId=null
}={}){
  const plan=createLiveStartPlan({
    session,
    items:bundle.items||[],
    preparations:bundle.preparations||[],
    woods:bundle.woods||[],
    stages:bundle.stages||[],
    stageTargets:bundle.stageTargets||[],
    itemTargets:bundle.itemTargets||[]
  });

  const activeStages=active(plan.stages);
  const requested=String(selectedStageId||'').trim();
  const stage=requested
    ?activeStages.find(value=>value.id===requested)
    :activeStages[0];

  if(!stage)throw new TypeError('Selected Live start stage is not part of the active plan');

  const warnings=[];
  if(!plan.session.smokerSnapshot){
    warnings.push(Object.freeze({
      code:'NO_SMOKER',
      message:'Plan nie ma przypisanej wędzarni.'
    }));
  }
  if(!plan.woods.length){
    warnings.push(Object.freeze({
      code:'NO_WOOD',
      message:'Plan nie ma zapisanej mieszanki drewna.'
    }));
  }

  return Object.freeze({
    ok:false,
    status:'confirmation_required',
    sessionId:plan.session.id,
    stageId:stage.id,
    stageName:stage.nameOverride||stage.typeKey,
    warningCount:warnings.length,
    warnings:Object.freeze(warnings),
    plan
  });
}
